module.exports = __webpack_public_path__ + "img/code-slash-outline.3502cba9.svg";